import { NextSeo } from 'next-seo';
import Head from 'next/head';
import { MercuryGate } from '@/screens/Integrations/MercuryGate';

export default function MercuryGatePage() {
  return (
    <>
      <Head>
        <meta
          name="keywords"
          content="logistics integrations, logistics partners, mercury gate"
        />
      </Head>
      <NextSeo
        nofollow={process.env.NOINDEX_FLAG}
        noindex={process.env.NOINDEX_FLAG}
        title="Logistics Partners | MercuryGate | Loadsmart"
        description="Our integration with MercuryGate helps you move more with less by delivering real-time market rates and automated booking natively into your MercuryGate transportation management system."
        canonical="https://loadsmart.com/integrations/mercury-gate/"
        openGraph={{
          url: 'https://loadsmart.com/integrations/mercury-gate/',
        }}
      />
      <MercuryGate />
    </>
  );
}
